import Vue from 'vue'
import Router from 'vue-router'
//引入页面
import Index from '../pages/index.vue'
import partrecommended from '../pages/PartRecommended.vue'
import aboutus from '../pages/AboutUs.vue'
import product from '../pages/product.vue'
import productstation from '../pages/Productstation.vue'
import service  from '../pages/service.vue'
// import Product from '../pages/product.vue'
// import service from '../pages/service.vue'
import Shop from '../pages/shop.vue'
import Policy from '../pages/policy.vue'
// import Question from '../pages/question.vue'
import Download from '../pages/download.vue'
import Relation from '../pages/relation.vue'
// import hR from '../pages/homeRecommand.vue'
import salesVolume from '../pages/salesVolume.vue'
import jointly from '../pages/jointly.vue'
import introduction from '../pages/introduction.vue'
import AppH5 from '../pages/AppH5.vue'
import AppPostH5 from '../pages/AppPostH5.vue'
import News from '../pages/News.vue'
import Link from '../pages/Link.vue'
import Year from '../pages/year.vue'
Vue.use(Router)

const routes = [{
		path: '*',
		redirect: '/index'
	},
	{
		path: '/index',
		component: Index,
		meta: {
			title: '乐范健康科技'
		}
	}, 
	{
		path: '/partrecommended',
		component: partrecommended,
		meta: {
			title: '部位推荐'
		}
	}, 
	{
		path: '/aboutus',
		component: aboutus,
		meta: {
			title: '关于我们'
		}
	}, 	
	{
		path: '/salesVolume',
		component: salesVolume,
		meta:{
			title: '销量领先产品'
		}
	},
	{
		path: '/jointly',
		component: jointly,
		meta:{
			title: '跨界联名产品'
		}
	},
	{
		path: '/product',
		component: product,
		meta: {
			title: '产品介绍'
		}
	},
	 {
	 	path: '/productstation',
	 	component: productstation,
	 	meta: {
	 		title: '产品站'
	 	}
	 }, 
	 {
	 	path: '/news',
	 	component: News,
	 	meta: {
	 		title: '新闻'
	 	}
	 },
	 {
		path: '/service',
		component: service,
		meta: {
			title: '服务支持'
		}
	},
	{
		path: '/shop',
		component: Shop,
		meta: {
			title: '官方网店'
		}
	}, 
	{
		path: '/policy',
		component: Policy,
		meta: {
			title: '售后政策'
		}
	}, 
	{
		path: '/introduction',
		component: introduction,
		meta: {
			title: '产品及视频介绍'
		}
	},
	// {
	// 	path: '/question',
	// 	component: Question,
	// 	meta: {
	// 		title: '常见问题'
	// 	}
	// }, 
	{
		path: '/download',
		component: Download,
		meta: {
			title: 'App下载'
		}
	},
	{
		path: '/relation',
		component: Relation,
		meta: {
			title: '联系我们'
		}
	}, 
	{
		path: '/AppH5',
		component:AppH5 ,
		meta: {
			title: '乐范健康'
		}
	},
	{
		path: '/AppPostH5',
		component:AppPostH5 ,
		meta: {
			title: '乐范健康'
		}
	},
	{
		path: '/link',
		component:Link ,
		meta: {
			title: '乐范健康'
		}
	},
	{
		path: '/year',
		component:Year ,
		meta: {
			title: '乐范健康'
		}
	},
	// {
	// 	path: '/Productstation',
	// 	component: Productstation,
	// 	meta: {
	// 		title: '产品站'
	// 	}
	// }
]

export default new Router({
	routes,
	mode: 'history',
})
